import { Series } from './Series';

/**
 * Class allowing to manage a Serie
 */
export class Series1D extends Series {
  constructor(array) {
    super(array, 1);
  }
}
